{
  "daily": "Hey. Let's keep going.",
  "shortGap": "You're back. Here's where things stand.",
  "longGap": "It's been a minute. Let's figure out what still matters.",
  "new": "Let's get started."
}
